import { useTranslation } from 'next-i18next'

import { useRouter } from 'next/router'

import ROUTES from '~/shared/constants/routes.const'
import { StackNLoadProductAPIStat } from '~/statistics/types/stack-n-load.types'
import { ButtonPrimary } from '~/components/Buttons'

import StatOverview from './StatOverview'
import StackNLoadIsland from './StackNLoadIsland'

export default function StackNLoadDetails({ product }: { product: StackNLoadProductAPIStat }): React.ReactElement {
  const { t } = useTranslation('statistics')
  const router = useRouter()
  const isFamilyView = router.asPath.includes(ROUTES.FAMILY_ADMIN_PANEL)

  const { summary, details } = product

  return (
    <div>
      <div className="flex space-x-4 my-4 pt-2">
        <StatOverview
          altText={t('stars')}
          imageSrcKey="scoreboard/star.svg"
          score={`${summary.collectedStarsCount}/${summary.totalStarsCount}`}
          title={t('stars')}
        />
        <StatOverview
          altText={t('gold_boxes')}
          imageSrcKey="scoreboard/gold-box.svg"
          score={`${summary.collectedGoldBoxesCount}/${summary.totalGoldBoxesCount}`}
          title={t('gold_boxes')}
        />
      </div>
      <div className="relative">
        <div>
          {details.map((island, islandNo) => (
            <StackNLoadIsland
              island={island}
              islandNo={islandNo + 1}
              key={island.title}
              lastIsland={details.length - 1 === islandNo}
            />
          ))}
        </div>
        {!isFamilyView && (
          <ButtonPrimary className="ml-auto mt-4 py-0.5 px-7" href={ROUTES.STACKNLOAD} noPadding size="medium">
            {t('play')}
          </ButtonPrimary>
        )}
      </div>
    </div>
  )
}
